import WrapRootElement from "./src/wrap-root-element";

export const wrapRootElement = WrapRootElement;
